var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-container"},_vm._l((_vm.treeData),function(node){return _c('treeNode',{key:node.id,attrs:{"nodeData":node},on:{"onNodeClick":_vm.onNodeClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }